<i18n>
{
  "en": {
    "filter_label": "Filter",
    "video_search": "Find Movies",
    "sort_label": "Sort Order",
    "sort_newest": "Newest",
    "sort_oldest": "Oldest",
    "sort_popular": "Popular",
    "movie_status": "Status",
    "status_vip": "VIP",
    "status_svip": "SVIP",
    "status_annual": "Annual",
    "movie_type": "Type",
    "type_vr": "VR",
    "type_fhd": "Full HD",
    "type_hd": "HD",
    "type_60fps": "60 fps",
    "other": "Other",
    "category_list": "Categories",
    "categories": "Categories",
    "series": "Series",
    "actresses": "Girls",
    "site_guide": "Site Guide",
    "faq": "FAQ",
    "contact": "Contact",
    "site_map": "Site Map",
    "recommended_sites": "Recommended Sites",
    "site_carib": "Caribbeancom",
    "site_caribpr": "Caribbeancom Premium",
    "site_dxlive": "DX LIVE",
    "site_1pondo": "1pondo",
    "site_10musume": "10musume",
    "site_heyzo": "HEYZO",
    "site_paco": "Pacopacomama"
  },
  "ja": {
    "filter_label": "フィルタ",
    "video_search": "動画検索",
    "sort_label": "並べ替え",
    "sort_newest": "新着順",
    "sort_oldest": "古い順",
    "sort_popular": "人気順",
    "movie_status": "配信ステータス",
    "status_vip": "VIP動画",
    "status_svip": "超VIP動画",
    "status_annual": "年間動画",
    "movie_type": "動画タイプ",
    "type_vr": "VR",
    "type_fhd": "Full HD",
    "type_hd": "HD",
    "type_60fps": "60 fps",
    "other": "その他",
    "category_list": "カテゴリー一覧",
    "categories": "カテゴリー",
    "series": "シリーズ一覧",
    "actresses": "女のコ検索",
    "site_guide": "サイトガイド",
    "faq": "ヘルプ",
    "contact": "お問い合わせ",
    "site_map": "サイトマップ",
    "recommended_sites": "おすすめサイト",
    "site_carib": "カリビアンコム",
    "site_caribpr": "カリビアンコムプレミアム",
    "site_dxlive": "DXLIVE",
    "site_1pondo": "一本道",
    "site_10musume": "天然むすめ",
    "site_heyzo": "HEYZO",
    "site_paco": "パコパコママ"
  }
}
</i18n>

<template>
<div class="list-filter">
  <button class="filter-toggle button is-flat is-large is-fullwidth" :class="{'is-open': showFilterMenu}" @click="filterMenuToggle()">
    <i class="iconf-filter is-left"></i>{{ $t('filter_label') }}
  </button>
  <transition name="slide">
  <div class="filter-contents" v-if="showFilterMenu">
    <div class="filter-section">
      <div class="filter-heading">{{ $t('sort_label') }}</div>
      <ul>
        <li><router-link to="/list/?page=1&o=newest"><i class="iconf-keyboard-arrow-right is-left"></i>{{ $t('sort_newest') }}</router-link></li>
        <li><router-link to="/list/?page=1&o=oldest"><i class="iconf-keyboard-arrow-right is-left"></i>{{ $t('sort_oldest') }}</router-link></li>
        <li><router-link to="/list/?page=1&o=bob"><i class="iconf-keyboard-arrow-right is-left"></i>{{ $t('sort_popular') }}</router-link></li>
      </ul>
    </div>
    <div class="filter-section" v-if="!newXPEligible">
      <div class="filter-heading">{{ $t('movie_status') }}</div>
      <ul>
        <li><router-link to="/search/?c=50000"><i class="iconf-keyboard-arrow-right is-left"></i>{{ $t('status_vip') }}</router-link></li>
        <li><router-link to="/search/?c=50001"><i class="iconf-keyboard-arrow-right is-left"></i>{{ $t('status_svip') }}</router-link></li>
      </ul>
    </div>
    <div class="filter-section">
      <div class="filter-heading">{{ $t('movie_type') }}</div>
      <ul>
        <li><router-link to="/search/?c=60000"><i class="iconf-keyboard-arrow-right is-left"></i>{{ $t('type_fhd') }}</router-link></li>
        <li><router-link to="/search/?c=60002"><i class="iconf-keyboard-arrow-right is-left"></i>{{ $t('type_hd') }}</router-link></li>
        <li><router-link to="/search/?c=60001"><i class="iconf-keyboard-arrow-right is-left"></i>{{ $t('type_60fps') }}</router-link></li>
        <li><router-link :to="`/search/?c=${vrCategoryID}`" v-if="showVRFilter" ><i class="iconf-keyboard-arrow-right is-left"></i>{{ $t('type_vr') }}</router-link></li>
      </ul>
    </div>
    <div class="filter-section">
      <div class="filter-heading">{{ $t('other') }}</div>
      <ul>
        <li><router-link to="/category/"><i class="iconf-keyboard-arrow-right is-left"></i>{{ $t('category_list') }}</router-link></li>
      </ul>
    </div>
  </div>
  </transition>
</div>
</template>

<script>
/* eslint max-len: 0 */
import BifrostAPI from '@/assets/js/services/Bifrost/API';

const VR_CATEGORY_ID = 94;

export default {
  data() {
    return {
      showFilterMenu: false,
      categories: {},
    };
  },
  async created() {
    // non-reactive consts
    this.vrCategoryID = VR_CATEGORY_ID;

    const bfAPI = new BifrostAPI();
    this.categories = await bfAPI.getCategories();
  },
  methods: {
    filterMenuToggle() {
      this.showFilterMenu = !this.showFilterMenu;
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    newXPEligible() {
      return this.$store.getters['user/isNewXPEligible'];
    },
    showVRFilter() {
      // show VR filter option if VR movies exist AND if we are in the classic experience
      // OR
      // if VR movies exist AND we are in the new experence and the config to hide VR is disabled
      return (Object.prototype.hasOwnProperty.call(this.categories, VR_CATEGORY_ID)
        && this.categories[VR_CATEGORY_ID].movie_count > 0
        && (!this.newXPEligible
          || (this.newXPEligible && process.env.VUE_APP_NEW_XP_HIDE_VR === 'false')));
    },
  },
};
</script>

<style lang="scss" scoped>
.slide-enter-active {
   transition-duration: 0.3s;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   transition-duration: 0.3s;
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 400px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}
</style>
